// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.TabContentTop_wrapper__3sfq6 {\n  display: flex;\n  margin-bottom: 16px; }\n  .TabContentTop_wrapper__3sfq6 > div {\n    display: flex;\n    margin-left: auto; }\n    .TabContentTop_wrapper__3sfq6 > div > * {\n      margin-right: 8px; }\n      .TabContentTop_wrapper__3sfq6 > div > *:last-child {\n        margin-right: 0; }\n  .TabContentTop_wrapper__3sfq6 .ant-input-affix-wrapper {\n    width: 256px; }\n  .TabContentTop_wrapper__3sfq6 .ant-btn-default {\n    color: #222222; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "TabContentTop_wrapper__3sfq6"
};
module.exports = exports;
